import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 }, url: String }

  connect() {
    this.timer = setInterval(() => this.#reload(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  #reload() {
    if (this.urlValue) {
      Turbo.visit(this.urlValue, { action: "replace" })
    }
  }
}
